import slugify from "react-slugify";

/*** This function as simple as possible, it is responsible for reduce unnecessary // into a single / */
export const simpleSlashes = (sentence: string) => {
    return sentence.replace(/\/+/g, '/');
}

export const convertToSlug = (title: string) => {
    const options: any = {
        lower: true,
        strict: true,
    };

    return slugify(title, options);
}